'use strict';

(function attachAssetManifestHelpers(windowObject) {
  if (typeof windowObject !== 'object') {
    return;
  }

  var hostname = window.location.hostname;
  var isDev = hostname === 'localhost' || hostname === '127.0.0.1';
  var manifestPath = isDev ? '/user/assets/json/fingerprints.json' : '/assets/fingerprints.json';

  const state = {
    loaded: false,
    data: {},
    promise: null
  };

  function fetchManifest() {
    if (state.loaded) {
      return Promise.resolve(state.data);
    }
    if (!state.promise) {
      state.promise = fetch(manifestPath, { credentials: 'same-origin' })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          // In dev mode or if fingerprints.json is missing, return empty manifest
          // This allows assets to work without hashing
          console.info('Asset manifest not found, using direct paths (dev mode)');
          return {};
        })
        .catch((error) => {
          // Silently handle fetch errors in dev mode
          console.info('Asset manifest fetch failed, using direct paths (dev mode)');
          return {};
        })
        .then((json) => {
          state.data = json || {};
          state.loaded = true;
          return state.data;
        });
    }
    return state.promise;
  }

  function resolveAssetPath(relativePath = '') {
    const normalized = String(relativePath || '').replace(/^\/+/, '');
    if (!normalized) {
      return relativePath;
    }
    const hashed = state.data[normalized];
    if (hashed) {
      const hashedNormalized = hashed.replace(/^\/+/, '');
      return `/${hashedNormalized}`;
    }
    return relativePath.startsWith('/') ? relativePath : `/${normalized}`;
  }

  windowObject.SoracomAssets = windowObject.SoracomAssets || {};
  windowObject.SoracomAssets.loadManifest = fetchManifest;
  windowObject.SoracomAssets.resolveAssetPath = resolveAssetPath;
})(window);

